'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(.1) translate3d(-2000px, 0, 0);\n      transform-origin: left center;\n    }\n'], ['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(.1) translate3d(-2000px, 0, 0);\n      transform-origin: left center;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = require('../BaseAnimation');

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomOutLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomOutLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomOutLeftAnimation);

exports.default = ZoomOutLeft;


//////////////////
// WEBPACK FOOTER
// ./~/animate-css-styled-components/lib/Zoom/OutLeft.js
// module id = 560
// module chunks = 95715928098905 168707334958949